import React, { Component } from 'react';
import { inject } from 'mobx-react';

import { localizable } from 'components/Localization';
import SaleInfo from './SaleInfo';

@inject('app')
@localizable
class DuplicateSummary extends Component {
  render() {
    const { store, t } = this.props;

    return (
      <div>
        <h2>{t('Summary')}</h2>

        <div style={{ paddingBottom: '1em' }}>
          <h3>{t('Duplicating sale')}</h3>
          <SaleInfo store={store} t={t} />
        </div>
      </div>
    );
  }
}

export default DuplicateSummary;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Duplicate/Summary.jsx